import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../Layout/index.jsx";
import { Button, Label, Modal, TextInput } from "flowbite-react";
import { IoMdAdd, IoMdArrowRoundBack } from "react-icons/io";
import { useGetAllCampusesQuery, useCreateCampusMutation } from "../../../../graphql/generated.tsx";

const Campus = () => {
  
  const navigate = useNavigate();
  const [campus, setCampus] = useState([]);
  const { data, loading, error } = useGetAllCampusesQuery();
  const [createCampus] = useCreateCampusMutation();
  const [openModal, setOpenModal] = useState(false);
  const [name, setName] = useState("");

  useEffect(() => {
    if (data) {
      setCampus(data.allCampus);
    }
  }, [data]);

  const handleCreateCampus = async () => {
    try {
      const { data: newCampusData } = await createCampus({
        variables: { createCampusInput: { name } },
      });
      setCampus((prevCampus) => [...prevCampus, newCampusData.createCampus]);
      setOpenModal(false);
      setName("");
    } catch (err) {
      console.error("Error creating campus:", err);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-screen">
          <p>Loading...</p>
        </div>
      </AdminLayout>
    );
  }

  if (error) return <AdminLayout>Error: {error.message}</AdminLayout>;

  return (
    <AdminLayout>
      <div className="p-10">
        {/* Header */}
        <div className="flex items-center justify-between mb-8 max-md:gap-2">
          <div className="flex items-center">
            <button
              onClick={() => window.history.back()}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <IoMdArrowRoundBack className="w-6 h-6" />
            </button>
            <div className="ml-2 text-2xl font-bold max-md:text-lg">
              All Campus
            </div>
          </div>
          <Button
            onClick={() => setOpenModal(true)}
            className="flex items-center px-3 py-1 text-white rounded-lg shadow-md bg-primary"
          >
            <IoMdAdd className="mt-1 mr-1" /> <span>Create Campus</span>
          </Button>
        </div>

        {/* Campus Cards */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {campus.map((c) => (
            <div
              key={c.id}
              onClick={() => navigate(`/admin/campus/${c.id}`)}
              className="relative cursor-pointer bg-white rounded-xl border border-gray-200 shadow-md p-5 flex flex-col items-center justify-center min-h-[120px] overflow-hidden transition-all duration-300 hover:bg-gradient-to-br hover:from-white hover:to-blue-50"
            >
              <h5 className="text-xl font-semibold text-center text-gray-800">
                {c.name}
              </h5>
              <div className="absolute bottom-0 left-0 w-full h-[5px] bg-gradient-to-r from-sky-700 via-sky-400 to-sky-200 rounded-b-xl" />
            </div>
          ))}
        </div>
        {/* Modal for creating campus */}
        <Modal
          show={openModal}
          size="md"
          popup
          onClose={() => setOpenModal(false)}
        >
          <Modal.Header />
          <Modal.Body>
            <div className="space-y-6">
              <h3 className="text-xl font-medium text-gray-900 dark:text-white">
                Create a new campus
              </h3>
              <div>
                <div className="block mb-2">
                  <Label htmlFor="name" value="Campus Name" />
                </div>
                <TextInput
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter campus name"
                  required
                />
              </div>
              <div className="w-full">
                <Button onClick={handleCreateCampus}>Create Campus</Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </AdminLayout>
  );
};

export default Campus;
